// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_3F3-zot","rotate":"_1EbMuyW","small":"_1PHabRi","medium":"_2SN11Ha","large":"_3x2345_","x-large":"_24EDmS-"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Spinner/index.css
// module id = ./template/components/Spinner/index.css
// module chunks = client.sitechrome